<template>
    <div class="vip-card">
        <div style="padding: 0px 10px;">
            <div class="vip-route-btn" @click="onClickCard">
                <div class="right-btn" :style="{
                    background: remainRewards == 0 ? '#002121' : 'linear-gradient(0deg, #1a7f7f 0%, #4ecdcd 100%)',
                    color: remainRewards == 0 ? '#ffffff33' : '#fff'
                }" @click="VIPClaim">
                    {{ $t('vip.collectEverything') }}
                </div>
            </div>
            <van-row style="display: flex; align-items: center;margin: 0 0 1.2rem;">
                <van-col class="initRow" span="8">
                    <div class="img-wrapper">
                        <img src="@/assets/themeFour/vip_level.png" />
                        <span class="img-text">{{ $t('vip.title') }}<span
                                style="margin-left:3px;font-weight: bolder;">{{ currentLevel }}
                            </span></span>
                    </div>
                </van-col>
                <van-col span="14">
                    <span style="color: rgba(255, 255, 255, .4);font-size: 1rem;font-weight: bold;">{{
                        $t('level.currentLevel') }}</span>
                </van-col>
            </van-row>

            <div class="vip-body">
                <div class="vip-section">
                    <van-row style="align-items: center;">
                        <van-col :span="19">
                            <div class="bar">
                                <span style="position: absolute;left: 35%;top: 6%;"></span>
                                <div class="progress"
                                    :style="{ width: betTotal / betMin < 1 ? (betTotal * 100) / betMin + '%' : '100%' }">
                                </div>
                            </div>
                        </van-col>
                        <van-col :span="4">
                            <div class="img-wrapper-bar">
                                <img src="@/assets/themeFour/vip_level.png" class="vip-img" />
                                <span class="img-text-bar">
                                    {{ $t('vip.title') }}<span style="margin-left:2px;font-weight: bolder;">{{
                                        nextLevel }}</span>
                                </span>
                            </div>
                        </van-col>
                    </van-row>
                </div>
            </div>
            <van-row>
                <van-col :span="24" style="padding: 1.2rem 0 0.8rem;">
                    <span style="color: rgba(255, 255, 255, .4);font-weight: bold;font-size: 1rem;">{{
                        $t('vip.criteria') }}</span>
                </van-col>
            </van-row>
            <van-row style="padding-bottom: 5rem;">
                <van-col :span="24">
                    <span style="color: rgba(255, 255, 255, .4);">• &nbsp;&nbsp;{{ $t('vip.betRequired') }}:
                        <span style="color: rgb(255, 154, 79);font-weight: bold;">
                            {{ formatCurrency(betTotal) }}</span> ({{ formatCurrency(betTotal) }} / {{
                                formatCurrency(betMin) }})
                    </span>
                </van-col>
            </van-row>
        </div>
    </div>

</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/user'
import { clickOnCard } from '@/view/profile/supportScript'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { formatCurrency } from '@/utils/commonFunction';

const router = useRouter()
const userStore = useUserStore()
const isPopping = ref(false)

const currentLevel = computed(() => userStore.VIPData.currentLevel)
const betTotal = computed(() => userStore.VIPData.cumulativeBetTotal)
const betMin = computed(() => userStore.VIPData.bet_min)
const nextLevel = computed(() => userStore.VIPData.nextLevel)
const onClickCard = () => clickOnCard(router, isPopping, '/sd-vip')

const emits = defineEmits(['claimVIP'])

const VIPClaim = () => {
    emits('claimVIP')
}

const props = defineProps<{
    remainRewards: number
}>()
</script>

<style scoped>
.vip-card {
    border-radius: 10px;
    color: #fff;
    cursor: pointer;
    transition: transform 0.2s ease;
    background: url('@/assets/themeFour/levelBg1.png') no-repeat;
    height: 12rem;
    background-position: bottom 0 left 0;
    background-size: 100% 100%;
    /* width: 100%; */
    margin: 15px;
    position: relative;
    padding: 20px 0;
}

.initRow img {
    width: 100%;
}

.vip-values {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #FFF;
    margin-bottom: 5px;
}

.vip-values-bottom {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #fe0;
    margin-top: 5px;
}

/* Progress bars */
.bar {
    position: relative;
    background: rgba(255, 255, 255, .2);
    border-radius: 20px;
    height: 5px;
    overflow: hidden;
}

.progress {
    background: #cececf;
    height: 100%;
    border-radius: 20px;
    transition: width 0.4s ease;
}

.progress.yellow {
    background: #f8d74a;
}

/* Animation */
.pop-animate {
    animation: pop-scale 0.3s ease;
}

@keyframes pop-scale {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(0.95);
    }

    100% {
        transform: scale(1);
    }
}

.vip-route-btn {
    position: absolute;
    top: -15px;
    right: 0px;
    width: 30%;
}

.vip-route-btn img {
    width: 100%;
    display: block;
}

.vip-route-btn span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    display: flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
}

.img-wrapper {
    position: relative;
    display: inline-block;
    width: 80%;
}

.img-wrapper-bar {
    position: relative;
    display: inline-block;
}

.img-wrapper-bar img {
    width: 110%;
    display: block;
}

.img-wrapper img {
    width: 110%;
    display: block;
}

.img-text {
    position: absolute;
    top: 50%;
    left: 75%;
    transform: translate(-50%, -50%);
    color: #ffffff;
    font-size: 16px;
    white-space: nowrap;
}

.img-text-bar {
    position: absolute;
    top: 50%;
    left: 90%;
    transform: translate(-50%, -50%);
    color: #ffffff;
    font-size: 10px;
    white-space: nowrap;
}

.vip-img {
    display: flex;
    width: 100%;
    padding-left: 10px;
}

.right-btn {
    border: #00615f solid 1px;
    font-size: 15px;
    font-weight: 500;
    white-space: nowrap;
    display: flex;
    justify-content: center;
    border-radius: 30px;
    padding: 20px 0;
}
@media (max-width: 450px){
    .right-btn{
        font-size: 12px;
        padding: 15px 0;
    }
    .vip-card{
        padding: 5px 0;
        height: 10rem;
    }
}
</style>
